import React from "react"
import ActionWrapper from "containers/ActionWrapper"
import LoadingIndicator from "components/LoadingIndicator"
import { createRequest } from "utils/request-helper"
import { addLeadingZero } from "utils/number-utils"

import glamorous from "glamorous"
import { inputStyle } from "components/Form/FormFields/FieldParts/Input"
import { submitButtonStyle } from "components/Form/FormFields/SubmitButton/"
import style from "utils/style"

class WithSearch extends React.Component {
  state = {
    query: "",
    results: [],
    meta: undefined,
    loading: false,
    filtersApplied: [],
    startYear: undefined,
    startMonth: undefined,
    startDay: undefined,
    startDate: undefined,
    endYear: undefined,
    endMonth: undefined,
    endDay: undefined,
    endDate: undefined,
  }

  constructor(props) {
    super(props)

    this.searchSubmit = this.searchSubmit.bind(this)
  }

  componentDidMount() {
    this.searchSubmit()
  }

  handleDateChange(e) {
    e.persist()

    let {
      startYear,
      startMonth,
      startDay,
      startDate,
      endYear,
      endMonth,
      endDay,
      endDate,
    } = this.state

    switch (e.target.name) {
      case "startYear":
        startYear = e.target.value
        break
      case "startMonth":
        startMonth = addLeadingZero(e.target.value)
        break
      case "startDay":
        startDay = addLeadingZero(e.target.value)
        break
      case "endYear":
        endYear = e.target.value
        break
      case "endMonth":
        endMonth = addLeadingZero(e.target.value)
        break
      case "endDay":
        endDay = addLeadingZero(e.target.value)
        break
      default:
        break
    }

    if (startYear && startMonth && startDay) {
      startDate = startYear + "-" + startMonth + "-" + startDay
    }

    if (endYear && endMonth && endDay) {
      endDate = endYear + "-" + endMonth + "-" + endDay
    }

    this.setState(
      {
        startYear,
        startMonth,
        startDay,
        startDate,
        endYear,
        endMonth,
        endDay,
        endDate,
      },
      () => {
        if (startDate && endDate) {
          this.searchSubmit()
        }
      }
    )
  }

  handleCheckChange(e) {
    let { filtersApplied } = this.state

    let newFilter = {
      name: e.target.name,
      value: e.target.value,
      checked: e.target.checked,
    }

    let result = filtersApplied.find(item => {
      return item.name === newFilter.name && item.value === newFilter.value
    })

    if (result === undefined && newFilter.checked) {
      filtersApplied.push(newFilter)
    } else {
      let index = filtersApplied.indexOf(result)
      filtersApplied.splice(index, 1)
    }

    this.setState({ filtersApplied })
    this.searchSubmit()
  }

  getAppliedFilterString() {
    return this.state.filtersApplied
      .map(filter => filter.name)
      .filter((item, i, array) => array.indexOf(item) === i)
      .map(name => `&filter[${name}]=` + this.getSeparatedValues(name))
      .reduce((combined, parts) => combined + parts, "")
  }

  getSeparatedValues(name) {
    return this.state.filtersApplied
      .filter(filter => filter.name === name)
      .reduce(
        (combined, filter, i, array) =>
          i === array.length - 1
            ? combined + filter.value
            : combined + filter.value + ",",
        ""
      )
  }

  getDateFilterStrings() {
    let string = ""
    if (this.state.startDate && this.state.endDate) {
      string = `&filter[campers-session-start-date]=${this.state
        .startDate}&filter[campers-session-end-date]=${this.state.endDate}`
    }
    return string
  }

  setLoading(isLoading) {
    this.setState({
      loading: isLoading,
    })
  }

  hideFilter(index) {
    let { filters } = this.props
    filters[index].hidden = !filters[index].hidden
    this.setState({ filters })
  }

  handleKeyPress(e) {
    if (e.charCode === 13) {
      this.searchSubmit()
    }
  }

  searchChanged(query) {
    this.setState({
      query: query,
    })
  }

  searchSubmit() {
    let route = `${this.props.route}?filter[strategy]=or`
    route += this.state.query !== "" ? `&filter[query]=${this.state.query}` : ""
    route += `${this.getAppliedFilterString()}${this.getDateFilterStrings()}`

    this.setLoading(true)
    createRequest(
      {
        method: "GET",
        route: route,
      },
      response => {
        this.setLoading(false)
        this.setState({
          results: response.data.data,
          meta: response.data.meta,
        })
      },
      error => {
        this.setLoading(false)
      }
    )
  }

  renderFilters(filters) {
    return filters.map((filter, i) => (
      <Filter key={i}>
        <FilterHeader onClick={() => this.hideFilter(i)}>
          <FilterTitle>{filter.name}</FilterTitle>
          <FilterHideButton>
            {filters[i].hidden ? "show" : "hide"}
          </FilterHideButton>
        </FilterHeader>
        <FilterOptions hide={filter.hidden}>
          {this.renderFilterOptions(filter, filter.hidden)}
        </FilterOptions>
      </Filter>
    ))
  }

  renderFilterOptions(filter, hide) {
    let change =
      filter.type === "checkbox"
        ? this.handleCheckChange.bind(this)
        : this.handleDateChange.bind(this)
    return filter.render(change, hide)
  }

  renderMetadata() {
    let totalCount = this.state.meta && this.state.meta["total-count"]
    let perPage = this.state.meta && this.state.meta["per-page"]

    return (
      <MetaCount>
        {totalCount <= perPage ? totalCount <= 1 ? totalCount === 0 ? (
          "No results found"
        ) : (
          "Displaying 1 result"
        ) : (
          "Displaying all " + totalCount + " results"
        ) : (
          "Displaying " + perPage + " of " + totalCount + " total results"
        )}
      </MetaCount>
    )
  }

  render() {
    return (
      <ActionWrapper direction={"row"} title={this.props.title}>
        {this.props.filters ? (
          <FilterColumn>{this.renderFilters(this.props.filters)}</FilterColumn>
        ) : null}

        <SearchColumn>
          <SearchHeader>
            <SearchInput
              placeholder="Search by name"
              onKeyPress={e => this.handleKeyPress(e)}
              onChange={e => this.searchChanged(e.target.value)}
            />
            <SubmitSearch onClick={() => this.searchSubmit()}>
              Search
            </SubmitSearch>
          </SearchHeader>

          {this.state.loading ? (
            <LoadingIndicator />
          ) : (
            <SearchBody>
              {this.state.meta && this.renderMetadata()}
              {this.props.renderResults(this.state.results)}
            </SearchBody>
          )}
        </SearchColumn>
      </ActionWrapper>
    )
  }
}

export default WithSearch

const FilterColumn = glamorous.div({
  display: "flex",
  flexDirection: "column",
  width: "30%",
  [style.size.desktop]: {
    width: "100%",
  },
})

const Filter = glamorous.div({
  padding: "1rem 2rem 1rem 0",
  [style.size.desktop]: {
    paddingRight: 0,
  },
})

const FilterTitle = glamorous.span({
  fontSize: "1.3rem",
  color: style.colors.boldGray,
  textTransform: "uppercase",
  letterSpacing: "2px",
})

const FilterOptions = glamorous.div(({ hide }) => ({
  padding: hide ? 0 : "5% 0 5% 0",
  transition: "all 0.15s",
  opacity: hide ? 0 : 1,
  height: hide && 0,
  overflow: hide && "hidden",
}))

const FilterHeader = glamorous.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "&:hover": {
    cursor: "pointer",
  },
})

const FilterHideButton = glamorous.button({
  color: style.colors.darkGreen,
  fontSize: "0.7rem",
  background: "none",
  border: "none",
  fontWeight: "bold",
  zIndex: 2,
  "&:hover": {
    cursor: "pointer",
  },
})

const MetaCount = glamorous.span({
  fontSize: "1.2rem",
  letterSpacing: 2,
  textTransform: "uppercase",
  color: style.colors.boldGray,
  paddingBottom: "1rem",
})

const SearchColumn = glamorous.div({
  display: "flex",
  flexDirection: "column",
  width: "70%",
  alignItems: "center",
  margin: 0,
  [style.size.desktop]: {
    width: "100%",
    paddingTop: "5%",
  },
})

const SearchInput = glamorous.input({
  ...inputStyle,
  width: "70%",
  borderColor: style.colors.gray,
  margin: 0,
})

const SubmitSearch = glamorous.button({
  ...submitButtonStyle,
  display: "flex",
  justifyContent: "center",
  width: "20%",
  minWidth: "4rem",
  margin: 0,
})

const SearchHeader = glamorous.div({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  margin: 0,
})

const SearchBody = glamorous.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  paddingTop: "5%",
})



// WEBPACK FOOTER //
// ./src/containers/WithSearch/index.js